import React from "react";
import Chip from "@hyro-components/Chip";
import { BENCHMARK_TYPES } from "./AnalyticsSettings.consts";

export const mergeOverrides = ({ defaults, overrides, edits, idField, valueField, defaultValueField }) => {
  const overrideMap = new Map(overrides.map((o) => [o[idField], o]));

  return defaults.map((defaultRow) => {
    const override = overrideMap.get(defaultRow[idField]);
    const editedValue = edits[defaultRow[idField]];
    const hasEdit = editedValue !== undefined;
    const resolvedValue = hasEdit ? editedValue : (override?.[valueField] ?? defaultRow[valueField]);

    return {
      ...defaultRow,
      [defaultValueField]: defaultRow[valueField],
      [valueField]: resolvedValue,
      isOverridden: resolvedValue !== defaultRow[valueField]
    };
  });
};

export const computeOverrideOps = ({
  edits,
  defaults,
  overrides,
  mutations,
  idField,
  valueField,
  basePayload
}) => {
  const ops = [];
  Object.entries(edits).forEach(([key, newValue]) => {
    const existingOverride = overrides?.find((o) => o[idField] === key);
    const defaultValue = defaults?.find((d) => d[idField] === key)?.[valueField];
    const payload = { ...basePayload, [idField]: key };

    if (newValue === defaultValue) {
      if (existingOverride) {
        ops.push(mutations.delete.mutateAsync(payload));
      }
    } else if (existingOverride) {
      ops.push(mutations.update.mutateAsync({ ...payload, [valueField]: newValue }));
    } else {
      ops.push(mutations.create.mutateAsync({ ...payload, [valueField]: newValue }));
    }
  });
  return ops;
};

export const setOrDropEdit = (setEdits, key, value, originalValue) => {
  if (value === originalValue) {
    setEdits((prev) => {
      const { [key]: _, ...rest } = prev;
      return rest;
    });
  } else {
    setEdits((prev) => ({ ...prev, [key]: value }));
  }
};

export const getOverrideTypeColumn = (columnDef) => ({
  ...columnDef,
  renderCell: ({ row }) =>
    row.isOverridden ? (
      <Chip
        label={BENCHMARK_TYPES.CUSTOM}
        size="small"
        backgroundColorPath={["tertiary", "300"]}
        textColorPath={["primary", "main"]}
      />
    ) : (
      BENCHMARK_TYPES.DEFAULT
    )
});
